import { Box, Card, CardActionArea, CardContent, Chip, Stack, Typography } from "@mui/material";
import type { FC } from "react";
import { Link as RouterLink } from "react-router-dom";
import PageTitle from "../../misc/PageTitle";
import type { ReportDefinition } from "./reportCatalog";
import { REPORTS, tint } from "./reportCatalog";

interface ReportCardProps {
  readonly report: ReportDefinition;
}

const ReportCard: FC<ReportCardProps> = ({ report }) => {
  const Icon = report.icon;
  return (
    <Card
      sx={{
        height: "100%",
        display: "flex",
        flexDirection: "column",
        transition: "0.3s",
        "&:hover": { transform: "translateY(-6px)", boxShadow: 6 },
      }}
    >
      <CardActionArea
        component={RouterLink}
        to={report.path}
        sx={{ flexGrow: 1, display: "flex", flexDirection: "column", alignItems: "stretch" }}
      >
        <CardContent sx={{ flexGrow: 1, p: 3 }}>
          <Stack direction="row" spacing={2} sx={{ alignItems: "flex-start", mb: 2 }}>
            <Box
              sx={{
                width: 52,
                height: 52,
                borderRadius: 2,
                bgcolor: tint(report.color),
                color: report.color,
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                flexShrink: 0,
              }}
            >
              <Icon />
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Chip label={report.category} size="small" variant="outlined" color="primary" sx={{ mb: 1 }} />
              <Typography variant="h6" component="h2" sx={{ fontWeight: "bold", lineHeight: 1.3 }}>
                {report.title}
              </Typography>
            </Box>
          </Stack>
          <Typography variant="body2" sx={{ color: "text.secondary" }}>
            {report.description}
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
};

const RaportyGallery: FC = () => (
  <Box>
    <PageTitle title="Raporty" />
    <Box sx={{ mb: 4 }}>
      <Typography variant="h4" component="h1" gutterBottom sx={{ fontWeight: "bold" }}>
        Galeria raportów
      </Typography>
      <Typography variant="body1" sx={{ color: "text.secondary", maxWidth: 820 }}>
        Wybierz raport systemowy — sprzedawcy, klienci lub dostawcy. Każdy raport obsługuje widok porównawczy
        split-screen z niezależnymi filtrami po obu stronach ekranu.
      </Typography>
    </Box>
    <Box sx={{ display: "grid", gridTemplateColumns: "repeat(auto-fill, minmax(320px, 1fr))", gap: 3 }}>
      {Object.values(REPORTS).map((report) => (
        <ReportCard key={report.path} report={report} />
      ))}
    </Box>
  </Box>
);

export default RaportyGallery;
